import React, { useState } from 'react';

const Newsletter = ({ id }) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError(''); // Clear any previous errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    // Create a unique callback name
    const callbackName = `mailchimpCallback_${Date.now()}`;
    
    try {
      // Create the JSONP URL with callback
      const baseUrl = 'https://dev.us18.list-manage.com/subscribe/post-json';
      const params = new URLSearchParams({
        u: '6f9040742c6759b7239a710d6',
        id: 'fa16e4d221',
        EMAIL: email,
        c: callbackName // JSONP callback parameter
      });
      
      const url = `${baseUrl}?${params.toString()}`;
      
      // Create a promise that will be resolved by the JSONP callback
      const jsonpPromise = new Promise((resolve, reject) => {
        // Set timeout to handle cases where callback never fires
        const timeoutId = setTimeout(() => {
          delete window[callbackName];
          if (document.head.contains(script)) {
            document.head.removeChild(script);
          }
          reject(new Error('Request timeout'));
        }, 10000); // 10 second timeout
        
        // Set up the callback function
        window[callbackName] = (data) => {
          clearTimeout(timeoutId);
          
          // Clean up
          delete window[callbackName];
          if (document.head.contains(script)) {
            document.head.removeChild(script);
          }
          
          // Debug: log the actual response
          console.log('Mailchimp response:', data);
          
          // Check for success
          if (data.result === 'success') {
            resolve(data);
          } else {
            // Mailchimp returned an error
            reject(new Error(data.msg || 'Subscription failed'));
          }
        };
        
        // Create and append script tag
        const script = document.createElement('script');
        script.src = url;
        script.onerror = () => {
          clearTimeout(timeoutId);
          delete window[callbackName];
          if (document.head.contains(script)) {
            document.head.removeChild(script);
          }
          reject(new Error('Network error'));
        };
        
        document.head.appendChild(script);
      });
      
      // Wait for the JSONP response
      const response = await jsonpPromise;
      console.log('Subscription successful:', response);
      
      // Success - show success state
      setIsSubmitted(true);
      setEmail('');
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      
      // Parse Mailchimp error messages
      let errorMessage = error.message;
      
      // Handle specific Mailchimp error patterns
      if (errorMessage.includes('already subscribed') || errorMessage.includes('is already a list member')) {
        errorMessage = 'Този email адрес вече е абониран за нашия бюлетин.';
      } else if (errorMessage.includes('invalid') || errorMessage.includes('enter a valid email')) {
        errorMessage = 'Моля, въведете валиден email адрес.';
      } else if (errorMessage.includes('too many') || errorMessage.includes('signup requests')) {
        errorMessage = 'Твърде много опити. Моля, опитайте отново по-късно.';
      } else if (errorMessage.includes('timeout')) {
        errorMessage = 'Заявката отне твърде дълго време. Моля, опитайте отново.';
      } else if (errorMessage.includes('Please enter a value') || errorMessage.includes('required')) {
        errorMessage = 'Email адресът е задължителен.';
      } else {
        errorMessage = 'Възникна грешка при абонирането. Моля, опитайте отново.';
      }
      
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div id={id} className="pb-8 fadein">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="md:flex">
            {/* Text section */}
            <div className="pt-6 pr-6 pl-6 md:pt-8 md:pr-8 md:pl-8 md:w-1/2">
              <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-3">Абонирайте се за нашия бюлетин</h2>
              <p className="text-gray-700">Получавайте най-новата информация за нашите инициативи и събития директно във вашата поща.</p>
            </div>
            
            {/* Form section */}
            <div className="p-6 md:p-8 md:w-1/2 bg-white">
              {!isSubmitted ? (
                <form onSubmit={handleSubmit} id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" noValidate>
                  <div className="mb-4">
                    <label htmlFor="mce-EMAIL" className="block text-gray-700 font-medium mb-1">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input 
                      type="email" 
                      id="mce-EMAIL" 
                      name="EMAIL" 
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent required email ${
                        error ? 'border-red-500' : 'border-gray-300'
                      }`}
                      required 
                      value={email}
                      onChange={handleChange}
                      placeholder="вашият@email.com"
                      disabled={isLoading}
                    />
                    {error && (
                      <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
                        <p className="text-sm text-red-600">{error}</p>
                      </div>
                    )}
                  </div>
                  
                  {/* Mailchimp honeypot field for bot protection */}
                  <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                    <input type="text" name="b_6f9040742c6759b7239a710d6_fa16e4d221" tabIndex="-1" defaultValue="" />
                  </div>
                  
                  <button 
                    type="submit" 
                    id="mc-embedded-subscribe"
                    className="w-full bg-green-700 text-white py-2 px-6 rounded-md hover:bg-green-600 transition-colors hover-grow disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Абониране...' : 'Абонирайте се'}
                  </button>
                </form>
              ) : (
                <div className="text-center p-6 bg-green-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-green-600 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h3 className="text-xl font-bold text-green-800 mb-2">Благодарим Ви!</h3>
                  <p className="text-green-700">Успешно се абонирахте за нашия бюлетин.</p>
                  <button 
                    onClick={() => setIsSubmitted(false)}
                    className="mt-4 text-green-600 hover:text-green-800 underline"
                  >
                    Абонирайте друг email
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter; 